import "core-js/stable";
import "regenerator-runtime/runtime";
import "./style/stylesheets/styles.scss";
import RitaAllenTheme from "./js/rita-allen-theme.js";
import TargetLinks from "./js/helpers/TargetLinks";

const theme = new RitaAllenTheme();
theme.init();
const targetLinks = new TargetLinks();
